import { type FC } from 'react';

/** Props for the screen recording video player. */
type ScreenRecordingProps = {
  /** URL to the video file (S3 or object URL). */
  url: string;
  /** Optional filename for the recording, used to derive a display label. */
  name?: string | null;
};

/** Screen recording displayed as an HTML5 video player with audio support. */
const ScreenRecording: FC<ScreenRecordingProps> = ({ url }) => (
  <figure role='group' className='my-2 max-w-lg'>
    <video
      src={url}
      controls
      preload='metadata'
      className='w-full rounded-lg'
      aria-label='Screen recording attachment'
    />
    <figcaption className='mt-1 text-xs text-on-surface-variant'>Screen Recording</figcaption>
  </figure>
);

export default ScreenRecording;
